import { useQuery } from "react-query";
import { getActiveConfieEmployeeCount } from "../../../../../actions/Employees";

const useGetActiveConfieEmployeeCount = () => {
  return useQuery(
    "GetActiveConfieEmployeeCount",
    getActiveConfieEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetActiveConfieEmployeeCount;
